import { Checkbox } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';


export default class ListaEvaluatori extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }


   

    render() {
        return (
            <ul className='evaluari-departamente'>
                {this.props.listaDepartamente.map((l, idx) => {


                    if (this.props.tip === 'evaluari_sefi') {
                        if (l.angajati.filter(a => a.sef_departament === 1).length > 0) {
                            return (
                                <li className='evaluari-departament' key={idx}>
                                    <div className='evaluari-departament-nume-line'>
                                        <div>
                                            {l.selectat ?
                                                <i onClick={() => { this.props.selecteazaDepartament(l, 'sef') }} style={{ color: 'rgb(24 165 58)' }} className='material-icons checkbox-departament' >check_box</i>
                                                : <i onClick={() => { this.props.selecteazaDepartament(l, 'sef') }} className='material-icons checkbox-departament' >check_box_outline_blank</i>
                                            }

                                            <span>{l.nume}</span>
                                        </div>
                                        <div>
                                            <i

                                                onClick={() => { this.props.arataUseri(l) }}
                                                style={{ fontSize: 20, verticalAlign: 'sub', marginRight: 10, cursor: 'pointer' }}
                                                className='material-icons'>{l.expandat ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>
                                        </div>

                                    </div>

                                    {l.expandat &&
                                        <div>
                                            <ul className='evaluari-angajati'>
                                                {l.angajati.filter(a => a.sef_departament === 1).map((a, idx2) => {
                                                    return (<li style={{color:a.disabled ? 'gray' : ''}} className='evaluari-departament' key={idx2}>
                                                        <div>
                                                            {a.selectat ?
                                                                <i onClick={() => { this.props.selecteazaAngajat(a, 'sef') }} style={{ color: 'rgb(24	165	58	)' }} className='material-icons checkbox-departament' >check_box</i>
                                                                : <i onClick={() => { this.props.selecteazaAngajat(a, 'sef') }} className='material-icons checkbox-departament' >check_box_outline_blank</i>
                                                            }

                                                            <span>{a.nume}</span>
                                                        </div>
                                                    </li>)
                                                })}

                                            </ul>
                                        </div>
                                    }

                                </li>
                            )

                        }
                    }else if(this.props.tip === 'evaluari_angajati'){
                        if (l.angajati.filter(a => a.sef_departament !== 1).length > 0) {
                            return (
                                <li className='evaluari-departament' key={idx}>
                                    <div className='evaluari-departament-nume-line'>
                                        <div>
                                            {l.selectat ?
                                                <i onClick={() => { this.props.selecteazaDepartament(l, 'angajati') }} style={{ color: 'rgb(24	165	58	)' }} className='material-icons checkbox-departament' >check_box</i>
                                                : <i onClick={() => { this.props.selecteazaDepartament(l, 'angajati') }} className='material-icons checkbox-departament' >check_box_outline_blank</i>
                                            }

                                            <span>{l.nume}</span>
                                        </div>
                                        <div>
                                            <i

                                                onClick={() => { this.props.arataUseri(l) }}
                                                style={{ fontSize: 20, verticalAlign: 'sub', marginRight: 10, cursor: 'pointer' }}
                                                className='material-icons'>{l.expandat ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>
                                        </div>

                                    </div>

                                    {l.expandat &&
                                        <div>
                                            <ul className='evaluari-angajati'>
                                                {l.angajati.filter(a => a.sef_departament !== 1).map((a, idx2) => {
                                                    return (<li style={{color:a.disabled ? 'gray' : ''}} className='evaluari-departament' key={idx2}>
                                                        <div>
                                                            {a.selectat ?
                                                                <i onClick={() => { this.props.selecteazaAngajat(a, 'angajati') }} style={{ color: 'rgb(24	165	58	)' }} className='material-icons checkbox-departament' >check_box</i>
                                                                : <i onClick={() => { this.props.selecteazaAngajat(a, 'angajati') }} className='material-icons checkbox-departament' >check_box_outline_blank</i>
                                                            }

                                                            <span>{a.nume}</span>
                                                        </div>
                                                    </li>)
                                                })}

                                            </ul>
                                        </div>
                                    }

                                </li>
                            )

                        }

                    }

                })}



            </ul>
        );
    }
}